import * as React from 'react';

function SvgVisaColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 54 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="VisaColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={33}
        y={8}
        width={9}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.692 8.752c-.578 0-.915.224-1.14.76l-3.108 7.413-.438 1.055c.827 0 1.63.002 2.434-.005.042 0 .104-.068.123-.117.137-.363.271-.726.394-1.094.041-.122.095-.167.23-.166.89.007 1.782.01 2.673-.002.179-.002.23.06.259.22.069.386.156.768.237 1.159h2.223v-.066c-.072-.311-.15-.622-.215-.934l-1.529-7.327c-.062-.298-.127-.595-.191-.896h-1.952zm.245 2.563l.029.006.704 3.377h-1.96l1.227-3.383z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.692 8.752c-.578 0-.915.224-1.14.76l-3.108 7.413-.438 1.055c.827 0 1.63.002 2.434-.005.042 0 .104-.068.123-.117.137-.363.271-.726.394-1.094.041-.122.095-.167.23-.166.89.007 1.782.01 2.673-.002.179-.002.23.06.259.22.069.386.156.768.237 1.159h2.223v-.066c-.072-.311-.15-.622-.215-.934l-1.529-7.327c-.062-.298-.127-.595-.191-.896h-1.952zm.245 2.563l.029.006.704 3.377h-1.96l1.227-3.383z"
          fill="url(#VisaColour_svg__paint0_linear)"
        />
      </g>
      <mask
        id="VisaColour_svg__b"
        maskUnits="userSpaceOnUse"
        x={26}
        y={8}
        width={8}
        height={11}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.78 8.588c-.045.011-.09.027-.137.033-.84.101-1.627.343-2.29.888-.763.627-1.131 1.434-1.025 2.427.072.663.448 1.162.968 1.537.405.292.86.514 1.288.775.275.167.564.32.805.529.366.317.327.823-.075 1.093-.185.124-.408.22-.627.262-.84.157-1.651.012-2.436-.304-.165-.066-.326-.141-.497-.216l-.43 2.015c.03.019.047.033.066.041.066.027.132.055.2.077a7.562 7.562 0 002.372.383h.004c.236 0 .473-.01.711-.033.754-.07 1.477-.26 2.115-.683 1.016-.674 1.464-1.627 1.313-2.836-.085-.684-.491-1.19-1.048-1.558-.473-.312-.983-.567-1.47-.86a3.544 3.544 0 01-.608-.438c-.262-.246-.258-.584.016-.82.16-.136.365-.245.569-.302.5-.139 1.01-.097 1.51.013.365.081.72.207 1.092.315l.416-1.945c-.282-.08-.541-.166-.806-.227-.29-.067-.586-.112-.88-.166h-1.115z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColour_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.78 8.588c-.045.011-.09.027-.137.033-.84.101-1.627.343-2.29.888-.763.627-1.131 1.434-1.025 2.427.072.663.448 1.162.968 1.537.405.292.86.514 1.288.775.275.167.564.32.805.529.366.317.327.823-.075 1.093-.185.124-.408.22-.627.262-.84.157-1.651.012-2.436-.304-.165-.066-.326-.141-.497-.216l-.43 2.015c.03.019.047.033.066.041.066.027.132.055.2.077a7.562 7.562 0 002.372.383h.004c.236 0 .473-.01.711-.033.754-.07 1.477-.26 2.115-.683 1.016-.674 1.464-1.627 1.313-2.836-.085-.684-.491-1.19-1.048-1.558-.473-.312-.983-.567-1.47-.86a3.544 3.544 0 01-.608-.438c-.262-.246-.258-.584.016-.82.16-.136.365-.245.569-.302.5-.139 1.01-.097 1.51.013.365.081.72.207 1.092.315l.416-1.945c-.282-.08-.541-.166-.806-.227-.29-.067-.586-.112-.88-.166h-1.115z"
          fill="url(#VisaColour_svg__paint1_linear)"
        />
      </g>
      <mask
        id="VisaColour_svg__c"
        maskUnits="userSpaceOnUse"
        x={12}
        y={8}
        width={12}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.68 8.894c-.78 1.986-1.565 3.97-2.35 5.956-.015.037-.037.072-.07.133-.021-.103-.037-.176-.05-.25-.318-1.68-.632-3.36-.952-5.04-.114-.592-.546-.94-1.146-.94h-3.79c-.263 0-.263 0-.267.276l.092.023c.707.168 1.401.374 2.07.669.416.183.638.482.75.92.604 2.387 1.227 4.77 1.839 7.155.035.137.085.19.238.189.722-.01 1.444-.008 2.166-.002.132.001.198-.033.252-.163 1.14-2.73 2.285-5.459 3.429-8.188.12-.285.238-.572.363-.872-.068-.003-.115-.008-.162-.008h-.622c-.526.001-1.051.001-1.577-.003h-.005c-.114 0-.165.037-.207.145z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColour_svg__c)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.68 8.894c-.78 1.986-1.565 3.97-2.35 5.956-.015.037-.037.072-.07.133-.021-.103-.037-.176-.05-.25-.318-1.68-.632-3.36-.952-5.04-.114-.592-.546-.94-1.146-.94h-3.79c-.263 0-.263 0-.267.276l.092.023c.707.168 1.401.374 2.07.669.416.183.638.482.75.92.604 2.387 1.227 4.77 1.839 7.155.035.137.085.19.238.189.722-.01 1.444-.008 2.166-.002.132.001.198-.033.252-.163 1.14-2.73 2.285-5.459 3.429-8.188.12-.285.238-.572.363-.872-.068-.003-.115-.008-.162-.008h-.622c-.526.001-1.051.001-1.577-.003h-.005c-.114 0-.165.037-.207.145z"
          fill="url(#VisaColour_svg__paint2_linear)"
        />
      </g>
      <mask
        id="VisaColour_svg__d"
        maskUnits="userSpaceOnUse"
        x={22}
        y={8}
        width={5}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.269 8.762l-1.973 9.218h.197c.656 0 1.313-.008 1.969.005.183.004.245-.052.283-.229.536-2.537 1.08-5.073 1.623-7.61l.295-1.384h-2.394z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#VisaColour_svg__d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.269 8.762l-1.973 9.218h.197c.656 0 1.313-.008 1.969.005.183.004.245-.052.283-.229.536-2.537 1.08-5.073 1.623-7.61l.295-1.384h-2.394z"
          fill="url(#VisaColour_svg__paint3_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="VisaColour_svg__paint0_linear"
          x1={13.792}
          y1={28.452}
          x2={41.509}
          y2={28.295}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColour_svg__paint1_linear"
          x1={13.777}
          y1={31.68}
          x2={41.493}
          y2={31.574}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColour_svg__paint2_linear"
          x1={13.817}
          y1={24.81}
          x2={41.533}
          y2={24.542}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
        <linearGradient
          id="VisaColour_svg__paint3_linear"
          x1={13.75}
          y1={42.716}
          x2={41.467}
          y2={42.675}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#262860" />
          <stop offset={1} stopColor="#3D439A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgVisaColour;
